module.exports = __webpack_public_path__ + "media/home/logo_white-f2e0513a.svg";